import UpdateProformaSales from "../../../../components/@documents/proforma_sales/UpdateProformaSales";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ProformaSalesUpdatePage() {

    return (
        <UpdateProformaSales 
            routeType={routeTypes.admin}
        />
    )
}